import React, { useEffect, useState } from "react"
import { getPublicStatus } from "../api"
import HealthGrid from "../Dashboard/HealthGrid"

const incidentColor = (s) => {
  if (s === "open") return "text-red-600"
  if (s === "resolved") return "text-green-600"
  return "text-neutral-500"
}

const StatusPage = ({ publicSlug }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)

  useEffect(() => {
    if (!publicSlug) return
    setLoading(true)
    getPublicStatus(publicSlug)
      .then((r) => {
        if (r?.error) return setErr(r.error)
        setData(r)
      })
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false))
  }, [publicSlug])

  if (loading) return <div className="p-8 text-center text-text_secondary">Loading...</div>
  if (err) return <div className="p-8 text-center text-error">Error: {err}</div>
  if (!data) return <div className="p-8 text-center text-text_secondary">Status page not found</div>

  const hasOpenIncidents = data.openIncidents?.length > 0
  const allUp = data.components?.every((c) => {
    const last = c.buckets?.[c.buckets.length - 1]
    return !last || last.value >= 0.99
  })

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <h1 className="text-2xl font-bold">{data.project?.name}</h1>
      <div className={`mt-2 text-lg font-semibold ${hasOpenIncidents ? "text-red-600" : allUp ? "text-green-600" : "text-amber-600"}`}>
        {hasOpenIncidents ? "Major incident in progress" : allUp ? "All Systems Operational" : "Partial outage"}
      </div>

      {/* Components grid */}
      <div className="mt-8 space-y-6">
        {data.components?.map((c) => (
          <div key={c._id} className="p-4 rounded-lg border border-bordered bg-paper">
            <div className="flex items-center justify-between mb-2">
              <div className="font-medium">{c.name}</div>
              {c.env && <span className="text-xs text-text_secondary bg-canvas px-2 py-0.5 rounded">{c.env}</span>}
            </div>
            <HealthGrid componentId={c._id} days={90} compact buckets={c.buckets} />
          </div>
        ))}
      </div>

      {/* Open incidents */}
      {hasOpenIncidents && (
        <div className="mt-8">
          <h2 className="text-lg font-semibold mb-3">Active Incidents</h2>
          <div className="space-y-3">
            {data.openIncidents.map((i) => (
              <div key={i._id} className="p-4 rounded-lg border border-red-200 bg-red-50 dark:bg-red-950/20">
                <div className="flex items-center justify-between">
                  <div className="font-medium">Incident</div>
                  <span className={`text-xs font-semibold ${incidentColor(i.status)}`}>{i.status}</span>
                </div>
                <div className="text-sm text-text_secondary mt-1">{i.reason}</div>
                <div className="text-xs text-text_secondary mt-1">
                  Opened: {new Date(i.openedAt).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default StatusPage
